import { render } from "./ClinicSchedulesTab.vue?vue&type=template&id=6bdc1099&scoped=true"
import script from "./ClinicSchedulesTab.js?vue&type=script&lang=js&external"
export * from "./ClinicSchedulesTab.js?vue&type=script&lang=js&external"

import "./ClinicSchedulesTab.vue?vue&type=style&index=0&id=6bdc1099&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdc1099"]])

export default __exports__